import { useHomeStore } from '@/stores/Home.store';
import I18nService from '@/services/i18n.service';
import PrintOSService from '@/services/PrintOS.service';

export default class HomeService {
  homeStore = useHomeStore();
  i18n = new I18nService();
  printOS = new PrintOSService();

  setParams(params) {
    let myParams = {};
    for (const [key, value] of Object.entries(params)) {
      if (window.$printos.helpers.v0.isEmpty(key)) {
        continue;
      }
      myParams[key] = decodeURIComponent(value);
    }

    this.homeStore.setParams(myParams);
  }

  getParams(params) {
    return this.homeStore.params;
  }

  setParam(name, value) {
    if (window.$printos.helpers.v0.isEmpty(name)) {
      console.warn('setParam name and value must have a value', name, value);
      return;
    }

    this.homeStore.setParam(name, value);
  }

  getParam(name) {
    let value = this.homeStore.params[name];
    if (!value) {
      value = Object.keys(this.homeStore.params).includes(name) ? true : null;
    }
    return value;
  }

  deleteParam(name) {
    this.homeStore.deleteParam(name);
  }

  deleteAllParams() {
    this.homeStore.deleteAllParams();
  }

  getReturnUrl(router) {
    let routerConfig = {
      name: 'signin',
    };

    let myParams = {};
    for (const [key, value] of Object.entries(this.homeStore.params)) {
      myParams[key] = key === 'username' ? value.replace(/@/g, '%40') : value;
    }

    routerConfig.query = myParams;

    const urlFragment = router.resolve(routerConfig).href;
    return window.location.origin + window.location.pathname + urlFragment;
  }
}
